import type { Dispatch, FC, SetStateAction } from "react";

import { Stack } from "@mui/material";
import CustomTextField from "../../../CustomTextField";

import { useTranslation } from "react-i18next";

interface SettingsTabActualVisitorsCaseProps {
  nameOfVisitors?: string;
  setNameOfVisitors?: Dispatch<SetStateAction<string>>;
}

export const SettingsTabActualVisitorsCase: FC<
  SettingsTabActualVisitorsCaseProps
> = ({ nameOfVisitors, setNameOfVisitors }) => {
  const { t } = useTranslation();

  return (
    <Stack
      direction='column'
      sx={{
        pt: 1,
        gap: 1.5,
        py: 2,
      }}
    >
      <CustomTextField
        fullWidth
        label={
          t(
            "campaign.notifications.settings.displayRules.actualVisitors.nameVisitors",
          ) ?? ""
        }
        value={nameOfVisitors ?? ""}
        onChange={e => {
          if (setNameOfVisitors) {
            setNameOfVisitors(e.currentTarget.value);
          }
        }}
      />
    </Stack>
  );
};
